module.exports = __webpack_public_path__ + "media/images/wedding/27-43a643c4effb6364f7a7fa318c821b75.jpg";